import {createContext} from "react";

export const AppContext = createContext<{
    desktopNavBarOpen: boolean;
    setDesktopNavBarOpen: (open: boolean) => void;
    mobileNavBarOpen: boolean;
    setMobileNavBarOpen: (open: boolean) => void;
    toggleNavBar: () => void;
    navbarExpanded: boolean;
}>({
    desktopNavBarOpen: false,
    setDesktopNavBarOpen: () => {},
    mobileNavBarOpen: false,
    setMobileNavBarOpen: () => {},
    toggleNavBar: () => {},
    navbarExpanded: false,
});
